<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
  <ng-template #createUpdateReport></ng-template>
  <div id="reporting" class="subBlockContainer">
    <!-- change [hidden] to *ngIf as [hidden] not working in IE10  -->
    <div class="background-disable" *ngIf="createActive"></div>
    <div class="blockContainer flexbox-style-one" id='levelOne'>
      <div class="breadcrumbWrapper">
        <app-breadcrumb></app-breadcrumb>
      </div>

      <div class="subBlockContent" [hidden]="narrowMode">
        <child-header [title]="title" (closeEvent)="close()"></child-header>
        <div class="child-body">
          <div class="inner-subBlock-wrapper">
              <!-- <div class="title blade-title-font">
                {{title}}
              </div>
              <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
                <div class="page-title-description">
                  Your Reporting Dashboard is a place where you can access standardised reports which provide detailed information pertaining to billing and usage data. 
                </div>
                <div class="top-divider"></div>
            <!-- <div class="menu-wrapper">
            </div> -->
          </div>
          <div class="inner-subBlock-wrapper inner-subBlock-wrapper-margin">
            <div class="row marginless-container">
              <div class="col-sm-12">
                  <div class="infoSection shadow-wrapper summary-transaction">
                  <div class="report-title summary-transaction-position">Transactional Summary</div>
                  <loading-icon [currentLoadingStatus]="chartLoadingStatus"></loading-icon>
                  <div class="row" [hidden]="chartLoadingStatus">
                    <canvas #chartTransactionalHistory id="chartTransactionalHistory" width="620" height="180"></canvas>
                  </div>
                </div>
              </div>
              <!--                 
                  <div class="col-lg-4">
                      <div class="infoSection shadow-wrapper">
                          <label class="company-name">90 Day Trending</label>
                          <div>
                          <canvas id="chartTrending" width="420" height="380"></canvas>
                          </div>
                      </div>
                  </div> -->

            </div>
          </div>

          <div class="inner-subBlock-wrapper" style="display:none;">
            <div class="page-subtitle-wrapper">YOUR PRODUCTS</div>
            <div class="row marginless-container">
              <div class="col-lg-4">
                <div class="infoSection shadow-wrapper">
                  <div class="company-name">Your Top 5 Brands</div>
                  <div>
                    <canvas id="chartTopBrands" width="420" height="380"></canvas>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="infoSection shadow-wrapper">
                  <label class="company-name">Your Top 5 SKUs</label>
                  <div>
                    <canvas id="chartTopSKU" width="420" height="380"></canvas>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="infoSection shadow-wrapper">
                  <div class="company-name">Product Reports</div>

                  <ng-container *ngFor="let item of productsMenu">
                    <div class="row reportLink" (click)="changeMode($event);">
                      <span [class]="'btn ' + item.menuIcon"></span>
                      &nbsp;&nbsp; {{item.menuName}}
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="inner-subBlock-wrapper">
            <div class="page-subtitle-wrapper"></div>
            <div class="row marginless-container">
              <!-- <div class="col-sm-8">
                <div class="infoSection shadow-wrapper">
                  <label class="company-name">90 Day Trending</label>
                  <div>
                    <canvas id="chartSubsTrending" width="420" height="380"></canvas>
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-lg-4"></div>  -->
              <div class="col-sm-6">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <label class="company-name">Business Reports</label>
                    <ng-container *ngFor="let item of businessMenu">
                      <div *ngIf="item.menuIcon == 'downloadButton'" [id]="item.menuId" class="row reportLink" (click)="downloadReports(item.menuName);">
                        <span [class]="'btn ' + item.menuIcon"></span>
                        &nbsp;&nbsp; {{item.menuName}}
                      </div>
                      <div *ngIf="item.menuIcon == 'settingButton'" class="row reportLink" (click)="changeMode($event);" [routerLink]="[item.menuRouter]">
                        <span [class]="'btn ' + item.menuIcon"></span>
                        &nbsp;&nbsp; {{item.menuName}}
                      </div>
                    </ng-container>
                  </div>
                </div>

              <div class="col-sm-6">
                <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                  <label class="company-name">Subscription Reports</label>
                  <ng-container *ngFor="let item of subscriptionMenu">
                    <div class="row reportLink" (click)="changeMode($event);" [routerLink]="[item.menuRouter]">
                      <span [class]="'btn ' + item.menuIcon"></span>
                      &nbsp;&nbsp; {{item.menuName}}
                    </div>
                  </ng-container>
                  <!-- <ng-container *ngIf="isStaffAccount"> -->
                  <ng-container>
                    <div class="row reportLink" (click)="downloadAdobeReports();">
                      <span [class]="'btn downloadButton2'"></span>
                      &nbsp;&nbsp; Adobe Schedule Renewal Reports
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="inner-subBlock-wrapper" style="display: none;">
            <div class="page-subtitle-wrapper top-divider"></div>
            <div class="page-subtitle-wrapper">YOUR CUSTOM REPORTS</div>
            <!-- <div *ngIf="reportList !== null" class="shared-outer-wrapper">
                  Add the reports here
                  <table matSort (matSortChange)="sortData($event)">
                      <thead>
                          <tr class="row catalogue-title-wrapper">
                              <th class="col-lg-2 col-md-2 col-sm-12" mat-sort-header="brand">REPORT NAME</th>
                              <th class="col-lg-6 col-md-4 col-sm-12">DATE MODIFIED</th>
                              <th class="col-lg-2 col-md-2 col-sm-12" mat-sort-header="dateModified">CREATED BY</th>
                              <th class="col-lg-2 col-md-4 col-sm-12 right-aligned-text"></th>
                          </tr>
                      </thead>
                      <tbody>
                          <ng-container *ngFor="let item of reportList>">
                          <ng-container *ngFor="let item of reportList> | singleSelectionPipe : catalogueFilterValue : selectedBrands : allSelected.selected : 'reports' ">
                              <tr class="catalogue-content-wrapper row " *ngIf="item?.published =='1'">
                                  <div class="col-lg-2 col-md-2 col-sm-12 orderNo-wrapper">{{reportList?.name}}</div>
                                  <div class="col-lg-6 col-md-4 col-sm-12">{{reportList?.description}}</div>
                                  <div class="col-lg-2 col-md-2 col-sm-12">{{dateFormat(reportList)}}</div>
                                  <div class="col-lg-2 col-md-4 col-sm-12 right-aligned-text">
                                      <div id="reportDownloadButton" (click)="exportExcelForReport(item?.id)"></div>
                                      <button (click)="createNewPopup(item?.id)" class="viewbtn">UPDATE</button>
                                  </div>
                              </tr>
                          </ng-container>
                      </tbody>
                  </table>
              </div> -->
            <div *ngIf="reportList === null" class="noData-wrapper">
              <div>
                <img src="../../images/new_ui/no-report.png">
              </div>
              <label class="noData-label">
                You have no custom<br />
                reports yet
              </label>
              <br />
              <button class="button button-red button-large" (click)="changeMode($event);" [routerLink]="['customreporting/new']">Create a new report</button>
              <br />
            </div>


          </div>
        </div>
        <!-- <loading-screen *ngIf="!loadContent" (currentLoadingStatus)="onLoading($event)"></loading-screen> -->

      </div>

      <div class="combination-loader narrow-sidebar" [hidden]="!narrowMode">
        <div class="child-sidebar sidebar-loader">
          <child-header [title]="title" (closeEvent)="close()" (closeEvent)="close()"></child-header>
          <!-- <div class="page-title-wrapper">
            <div class="title blade-title-font">
              {{title}}
            </div>
            <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i>
          </div> -->
          <div class="child-body child-body-narrowMode">
            <div class="infoSection-title" id="first-title">YOUR BUSINESS</div>
            <ng-container *ngFor="let item of businessMenu">
              <div *ngIf="item.menuIcon == 'downloadButton'" [id]="item.menuId" class="row menu-wrapper" (click)="downloadReports(item.menuName);">
                <span [class]="'btn margin-left-0 ' + item.menuIcon"></span>
                &nbsp;
                <span class="reportLink menu-font padding-top-4">{{item.menuName}}</span>
              </div>
              <div *ngIf="item.menuIcon == 'settingButton'" class="row menu-wrapper" [routerLink]="[item.menuRouter]" routerLinkActive="active">
                <span [class]="'btn margin-left-0 ' +item.menuIcon"></span>
                &nbsp;
                <span class="reportLink menu-font padding-top-4">{{item.menuName}}</span>
              </div>
            </ng-container>

            <!-- <div class="infoSection-title">YOUR PRODUCTS</div>
                <ng-container *ngFor="let item of productsMenu">
                    <div class="row menu-wrapper" [routerLink]="[item.menuRouter + '/' + item.menuName]">
                            <span [class]="'btn margin-left-0 ' +item.menuIcon"></span>
                        &nbsp;
                        <span class="reportLink padding-top-4">{{item.menuName}}</span>
                    </div>
                </ng-container> -->

            <div class="infoSection-title">YOUR SUBSCRIPTIONS</div>
            <ng-container *ngFor="let item of subscriptionMenu">
              <div class="row menu-wrapper" [routerLink]="[item.menuRouter]" routerLinkActive="active">
                <span [class]="'btn margin-left-0 ' +item.menuIcon"></span>
                &nbsp;
                <span class="reportLink menu-font padding-top-4">{{item.menuName}}</span>
              </div>
            </ng-container>

            <!-- <div class="top-divider"></div> -->
            <!-- <div class="infoSection-title">YOUR CUSTOM REPORTS</div> -->
            <!-- <ng-container *ngFor="let item of subscriptionMenu">
                    <div class="row menu-wrapper" [routerLink]="[item.menuRouter]" routerLinkActive="active">
                            <span [class]="'btn margin-left-0 ' +item.menuIcon"></span>
                        &nbsp;
                        <span class="reportLink padding-top-4">{{item.menuName}}</span>
                    </div>
                </ng-container> -->

            </div>
        </div>
        <div id="childLoader" class="child-loader">
          <router-outlet></router-outlet>
        </div>
      </div>

    </div>

  </div>
</div>
